import { Autocomplete, Backdrop, Box, Button, Chip, Fade, FormControl, FormControlLabel, Grid, Modal, Radio, RadioGroup, TextField, Typography } from "@mui/material"
import { useLoading } from "../../../../../components/Loading/useLoading";
import { useContext, useEffect, useRef, useState } from "react";
import { ThemeContext } from "@emotion/react";
import { Delete } from "@mui/icons-material";
import swal from "sweetalert2";
import { EstatusMovimientoEnum } from "../../../../../@enums/status_mov_inv";
import { VerifyMov } from "../../../../../hooks/verifyMov";
import { useSelector } from "react-redux";
import { ReimprimirEtiquetas } from "../../../../../hooks/reimprimirEtiquetas";
import { TicketLocal } from "../../../../../hooks/sendPrint";
import { ModalConfirmacionTag } from "./modalConfirmacionTag";
import { set } from "react-hook-form";
import { VerifyTag } from "../../../../../hooks/verifyTag";
import { GetClientsList } from "../../../../../hooks/getListClientes";
import { GetPartsClientsList } from "../../../../../hooks/getPartesClienteList";

const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 900,
  maxWidth: 1000,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  display: "flex",
  justifyContent: "center",
};


export const ModalEtiquetas = ({ open, setOpen, almacen, get_movimientos }) => {

  const formData = useRef(null);
  const inputRefTags = useRef(null);
  const theme = useContext(ThemeContext);
  const { setAppLoading } = useLoading();
  const { verifyMovMutation } = VerifyMov();
  const { verifyTagMutation } = VerifyTag();
  const { reimprimirEtiquetasMutation } = ReimprimirEtiquetas();
  const { ticketLocalMutation } = TicketLocal();
  const { isLoading: isLoadingClients, isError: isErrorClients, data: clients, refetch: refetchClients } = GetClientsList();
  const [clienteSelect, setClientSelect] = useState(null);
  const { isLoading: isLoadingParts, isError: isErrorParts, data: parts = [], refetch: refetchParts } = GetPartsClientsList(clienteSelect?.value);
  const [paquetes, setPaquetes] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [dataReprint, setDataReprint] = useState([]);
  const [seccion, setSeccion] = useState(1);
  const [parte, setParte] = useState(null);
  const printerId = useSelector((state) => state.app.printerId);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (inputRefTags.current) {
          inputRefTags.current.focus();
        }
      }, 200); // Esperar un corto tiempo para asegurarse de que el modal esté completamente renderizado
    }
  }, [open]);

  const handleClose = () => {
    setPaquetes([]);
    setOpen(false);
    setDataReprint([]);
    setOpenConfirm(false);
    setClientSelect(null);
    setParte(null);
    setSeccion(1);
  };

  const deleteItem = (index) => {
    let paq = paquetes;
    paq.splice(index, 1);
    setPaquetes([...paq]);
  }

  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      setAppLoading(true)
      event.preventDefault();
      if (paquetes.some((item) => item.tag === event.target.value)) {
        setAppLoading(false)
        swal.fire({
          position: "center",
          icon: "warning",
          title: "El contenedor ya ha sido agregado",
          width: 600,
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            container: "cont_alt",
          },
        });
      } else {
        let body = {
          moin_estatus: EstatusMovimientoEnum.ACTIVO,
          alma_entrada: almacen,
          movimientos_inventario_etiquetas: {
            etiquetas: {
              etiq_estatus: true,
              etiq_codigo: event.target.value
            }
          }
        };
        let body_master = {
          moin_estatus: EstatusMovimientoEnum.ACTIVO,
          alma_entrada: almacen,
          movimientos_inventario_etiquetas: {
            etiquetas: {
              etiq_estatus: true,
              etiqueta_padre: {
                etiq_estatus: true,
                etiq_codigo: event.target.value
              }
            }
          }
        };
        verifyMovMutation({ where: body, validate_master: false, where_master: body_master }, {
          onSuccess: (data) => {
            if (data.success !== false) {
              setPaquetes([
                ...paquetes,
                {
                  id: data?.data?.id,
                  tag: data?.data?.tag,
                  data: data?.data?.tag_id,
                  cantidad: data?.data?.cantidad
                },
              ]);
              formData.current.etiqueta.value = "";
              setAppLoading(false)
            } else {
              setAppLoading(false)
              swal.fire({
                position: "center",
                icon: "error",
                title:
                  "El contenedor no existe o no cumple con las condiciones necesarias",
                width: 600,
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  container: "cont_alt",
                },
              });
            }
          },
          onError: (error) => {
            console.log(error);
            swal.fire({
              position: "center",
              icon: "error",
              title:
                "El contenedor no existe o no cumple con las condiciones necesarias",
              width: 600,
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                container: "cont_alt",
              },
            });
          },
        });
      }
      inputRefTags.current.focus();
    }
  }

  const handleEnterPressMaster = (event) => {
    if (event.key === "Enter") {
      setAppLoading(true)
      event.preventDefault();
      let body = {
        moin_estatus: EstatusMovimientoEnum.ACTIVO,
        alma_entrada: almacen,
        movimientos_inventario_etiquetas: {
          etiquetas: {
            etiq_estatus: true,
            etiq_codigo: event.target.value
          }
        }
      };
      let body_master = {
        moin_estatus: EstatusMovimientoEnum.ACTIVO,
        alma_entrada: almacen,
        movimientos_inventario_etiquetas: {
          etiquetas: {
            etiq_estatus: true,
            etiqueta_padre: {
              etiq_estatus: true,
              etiq_codigo: event.target.value
            }
          }
        }
      };
      verifyMovMutation({ where: body, validate_master: false, where_master: body_master }, {
        onSuccess: (data) => {
          if (data.success !== false) {
            setPaquetes([
              ...paquetes,
              {
                id: data?.data?.tag_id,
                tag: data?.data?.tag,
                tag_id: data?.data?.tag_id,
                data: data?.data?.tag_id,
                isMaster: true
              },
            ]);

            searchByMaster(data?.data?.tag);
          } else {
            setAppLoading(false)
            swal.fire({
              position: "center",
              icon: "error",
              title:
                "El contenedor no existe o no cumple con las condiciones necesarias",
              width: 600,
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                container: "cont_alt",
              },
            });
          }
        },
        onError: (error) => {
          console.log(error);
          swal.fire({
            position: "center",
            icon: "error",
            title:
              "El contenedor no existe o no cumple con las condiciones necesarias",
            width: 600,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              container: "cont_alt",
            },
          });
        },
      });
    }
  }

  const handleEnterParte = () => {
    setAppLoading(true);
    let body = {
      moin_estatus: EstatusMovimientoEnum.ACTIVO,
      alma_entrada: almacen,
      part_id: parte?.value,
      movimientos_inventario_etiquetas: {
        etiquetas: {
          etiq_estatus: true
        }
      }
    };
    let body_master = {
      moin_estatus: EstatusMovimientoEnum.ACTIVO,
      alma_entrada: almacen,
      part_id: parte?.value,
      movimientos_inventario_etiquetas: {
        etiquetas: {
          etiq_estatus: true,
          etiqueta_padre: {
            etiq_estatus: true
          }
        }
      }
    };
    console.log(parte)
    verifyMovMutation({ where: body, validate_master: false, where_master: body_master, byParte: true }, {
      onSuccess: (data) => {
        if (data.success !== false) {
          let news = data?.data?.map(i => {
            return {
              id: i?.id,
              tag: i?.tag,
              tag_id: i?.tag_id,
              cantidad: i?.cantidad
            }
          })
          console.log(news)
          setPaquetes([
            ...paquetes,
            ...news
          ]);
          setAppLoading(false)
        } else {
          setAppLoading(false)
          swal.fire({
            position: "center",
            icon: "error",
            title:
              "El contenedor no existe o no cumple con las condiciones necesarias",
            width: 600,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              container: "cont_alt",
            },
          });
        }
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false)
        swal.fire({
          position: "center",
          icon: "error",
          title:
            "El contenedor no existe o no cumple con las condiciones necesarias",
          width: 600,
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            container: "cont_alt",
          },
        });
      },
    });
  }

  const searchByMaster = (etiq_codigo) => {
    let body = {
      etiq_codigo
    };
    setAppLoading(true)
    verifyTagMutation({ almacen: almacen, data: body }, {
      onSuccess: (data) => {
        setAppLoading(false)
        if (data.success !== false && data.data?.length > 0) {
          if (paquetes.length > 0 && paquetes[0].parte !== data.data[0].parte) {
            swal.fire({
              position: "center",
              icon: "error",
              title:
                "El contenedor no existe o no cumple con las condiciones necesarias",
              width: 600,
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                container: "cont_alt",
              },
            });
          } else {
            setPaquetes(prev => [...prev, ...data?.data]);
          }
        }
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false)
        swal.fire({
          position: "center",
          icon: "error",
          title:
            "El contenedor no existe o no cumple con las condiciones necesarias",
          width: 600,
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            container: "cont_alt",
          },
        });
      },
    });
  };

  const send_reprint = () => {
    let tags_send = paquetes.map((paquete) => {
      return {
        id: paquete?.id,
        data: paquete?.data
      }
    })
    swal.fire({
      title: "Esta seguro de reimprimir las etiquetas",
      text: "Se eliminaran las etiquetas actuales y se asignaran las nuevas",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, reimprimir",
      customClass: {
        container: "cont_alt",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);
        reimprimirEtiquetasMutation({ printerId, etiquetas: tags_send, almacen }, {
          onSuccess: (data) => {
            swal.fire({
              position: "top-end",
              icon: "success",
              title: data.mensaje,
              showConfirmButton: false,
              timer: 1500
            })
            setDataReprint(data?.data);
            for (let print of data?.data) {
              ticketLocalMutation(print, {
                onSuccess: (data) => {
                  console.log(data)
                },
                onError: (error) => {
                  console.log(error)
                }
              })
            }
            // setOpenConfirm(true);
            handleClose();
            get_movimientos(almacen);
            setAppLoading(false);
          },
          onError: (error) => {
            setAppLoading(false);
            swal.fire({
              position: "top-end",
              icon: "error",
              title: "Hubo un error al reimprimir",
              text: "Intenta de nuevo",
              showConfirmButton: false,
              timer: 1500
            })

          }
        })
      }
    });
  }

  const send_reprint_hijas = (all) => {
    let etiquetas = all ? paquetes : paquetes.filter(p => !p.isMaster)
    etiquetas = etiquetas.map((paquete) => {
      return {
        id: paquete?.isMaster ? null : paquete?.id,
        data: paquete?.tag_id,
      }
    })
    console.log(etiquetas)
    swal.fire({
      title: "Esta seguro de reimprimir las etiquetas",
      text: "Se eliminaran las etiquetas actuales y se asignaran las nuevas",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, reimprimir",
      customClass: {
        container: "cont_alt",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);
        reimprimirEtiquetasMutation({ printerId, etiquetas, almacen }, {
          onSuccess: async (data) => {
            swal.fire({
              position: "top-end",
              icon: "success",
              title: data.mensaje || "Se han reimpreso las etiquetas",
              showConfirmButton: false,
              timer: 1500
            })
            await setDataReprint(data?.data);
            for (let print of data?.data) {
              await ticketLocalMutation(print, {
                onSuccess: (data) => {
                  console.log(data)
                },
                onError: (error) => {
                  console.log(error)
                }
              })
            }
            // setOpenConfirm(true);
            get_movimientos(almacen);
            handleClose();
            setAppLoading(false);
          },
          onError: (error) => {
            setAppLoading(false);
            swal.fire({
              position: "top-end",
              icon: "error",
              title: "Hubo un error al reimprimir",
              text: "Intenta de nuevo",
              showConfirmButton: false,
              timer: 1500
            })

          }
        })
      }
    });
  }

  const changeSeccion = (e) => {
    setSeccion(parseInt(e.target.value));
    setPaquetes([]);
  }

  const handleChangeClient = (newValue) => {
    setParte(null);
    if (newValue === null) {
      setClientSelect(null);
    } else {
      setClientSelect(newValue);
    }
  }
  const handleChangePart = (newValue) => {
    if (newValue === null) {
      setParte(null);
    } else {
      setParte(newValue);
    }
  }

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="modal_carga">
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sx={{ p: 0, mb: 1, pr: 1 }}
                className="center_item"
              >
                <Typography
                  id="transition-modal-title"
                  variant="h6"
                  component="h2"
                >
                  Reimpresion de Etiquetas
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={5}
                xl={5}
                sx={{
                  p: 1,
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  flexDirection: "column",
                }}
              >
                <form ref={formData} id="form_dom" style={{ width: "100%" }}>
                  <FormControl sx={{ mb: 2 }}>
                    <RadioGroup
                      aria-labelledby="radio_merge"
                      name="radio_merge"
                      value={seccion}
                      onChange={changeSeccion}
                      row
                    >
                      <FormControlLabel value={1} control={<Radio />} label="Etiqueta" />
                      <FormControlLabel value={2} control={<Radio />} label="Master" />
                      <FormControlLabel value={3} control={<Radio />} label="Producto" />
                    </RadioGroup>
                  </FormControl>
                  {seccion === 1 &&
                    <>
                      <TextField
                        id="etiqueta"
                        size="small"
                        label="Etiqueta"
                        fullWidth
                        inputRef={inputRefTags}
                        onKeyDown={handleEnterPress}
                        sx={{ color: theme.palette.primary.input, width: "100%" }}
                      />
                      <Button
                        variant="contained"
                        className="btn_system"
                        sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                        disableElevation
                        disabled={paquetes.length === 0}
                        onClick={send_reprint}
                      >
                        Reimprimir
                      </Button>
                    </>
                  }
                  {seccion === 2 &&
                    <>
                      <TextField
                        id="etiqueta_master"
                        size="small"
                        label="Etiqueta Master"
                        fullWidth
                        onKeyDown={handleEnterPressMaster}
                        sx={{ color: theme.palette.primary.input, width: "100%" }}
                      />
                      <Button
                        variant="contained"
                        className="btn_system"
                        sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                        disableElevation
                        disabled={paquetes.length === 0}
                        onClick={() => send_reprint_hijas(true)}
                      >
                        Reimprimir todo
                      </Button>
                      <Button
                        variant="contained"
                        className="btn_system"
                        sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                        disableElevation
                        disabled={paquetes.length === 0}
                        onClick={() => send_reprint_hijas(false)}
                      >
                        Reimprimir etiquetas individuales
                      </Button>
                    </>
                  }
                  {seccion === 3 &&
                    <>
                      <Autocomplete
                        fullWidth
                        id="emp_id"
                        getOptionLabel={(opcion) => opcion.label}
                        filterSelectedOptions
                        options={clients}
                        onKeyDown={handleKeyUp}
                        value={clienteSelect}
                        onChange={(e, newValue) => handleChangeClient(newValue)}
                        renderOption={(props, option) => (
                          <Box {...props} key={option?.value}>{option.label}</Box>
                        )}
                        renderInput={(params) =>
                          <TextField {...params} label="Cliente" size="small" fullWidth required />
                        }
                      />

                      <Autocomplete
                        fullWidth
                        id="part_id"
                        getOptionLabel={(opcion) =>
                          opcion?.codigo !== undefined ?
                            `${opcion?.label} / ${opcion?.codigo} / ${opcion?.codigo_salida} / ${opcion?.codigo_alterno}` :
                            opcion?.label
                        }
                        sx={{ mt: 2 }}
                        filterSelectedOptions
                        options={parts}
                        onKeyDown={handleKeyUp}
                        value={parte}
                        disabled={!parts || !clienteSelect}
                        onChange={(e, newValue) => handleChangePart(newValue)}
                        renderOption={(props, option) => (
                          <Box {...props} key={option?.value}>
                            {option?.codigo !== undefined ? option?.codigo : <></>} /
                            {option?.codigo_salida !== undefined ? option?.codigo_salida : <></>} /
                            {option?.codigo_alterno !== undefined ? option?.codigo_alterno : <></>} / {option?.label}
                          </Box>
                        )}
                        renderInput={(params) =>
                          <TextField {...params} label="Parte" size="small" fullWidth required />
                        }
                      />
                      {
                        paquetes.length === 0 &&
                        <Button
                          variant="contained"
                          className="btn_system"
                          sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                          disableElevation
                          disabled={!parte}
                          onClick={handleEnterParte}
                        >
                          Buscar
                        </Button>
                      }
                      {
                        paquetes.length > 0 &&
                        <>
                          <Button
                            variant="contained"
                            className="btn_system"
                            sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                            disableElevation
                            disabled={paquetes.length === 0}
                            onClick={() => send_reprint_hijas(true)}
                          >
                            Reimprimir
                          </Button>
                          <Button
                            variant="outlined"
                            className="btn_system"
                            sx={{ fontSize: 12, height: 35, mt: 2.5 }}
                            disableElevation
                            onClick={() => {
                              setPaquetes([]);
                              setParte(null);
                              setClientSelect(null);
                            }}
                          >
                            Limpiar
                          </Button>
                        </>

                      }
                    </>
                  }
                </form>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={7}
                xl={7}
                sx={{
                  p: 1,
                  gap: 2,
                  display: "flex",
                  alignItems: "flex-start",
                  border: "1px solid #D9D9D9",
                  borderRadius: 5,
                }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{
                    p: 1,
                    textAlign: "start",
                    display: "flex",
                    alignItems: "center",
                    overflowY: 'scroll',
                    maxHeight: '400px'
                  }}
                >
                  {paquetes?.map((paq, index) => (
                    <>
                      <Grid
                        item
                        xs={6}
                        sx={{
                          p: 1,
                          textAlign: "start",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Chip
                          label={
                            <div
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  marginRight: 7,
                                  fontSize: 12,
                                  fontWeight: 400,
                                  color: "black",
                                }}
                              >
                                {paq?.cantidad}
                              </span>
                              <span
                                style={{
                                  marginLeft: 7,
                                  border: "1px solid #575E3B",
                                  borderRadius: 4,
                                  fontSize: 11,
                                  padding: 3,
                                  color: "#575E3B",
                                }}
                              >
                                {paq?.tag}
                              </span>
                            </div>
                          }
                          variant="outlined"
                          deleteIcon={
                            <Delete sx={{ marginLeft: "5px !important", width: 18 }} />
                          }
                          onDelete={() => deleteItem(index)}
                          sx={{
                            height: 40,
                            borderRadius: 2,
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            backgroundColor: "transparent",
                          }}
                        />
                      </Grid>
                    </>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
      {/* <ModalConfirmacionTag key='modal_confirm' open={openConfirm} setOpen={setOpenConfirm} dataReprint={dataReprint} onClose={handleClose} /> */}
    </>
  )
}